"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PhotoEditor_1 = __importDefault(require("../PhotoEditor"));
var config_1 = __importDefault(require("../config"));
var MediaManagerImage_1 = require("../MediaManagerImage");
var MAX_SIZE = 2000;
var MediaManagerPhotoEditor = /** @class */ (function (_super) {
    __extends(MediaManagerPhotoEditor, _super);
    function MediaManagerPhotoEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function (data) {
            var _a = _this.state, naturalHeight = _a.naturalHeight, naturalWidth = _a.naturalWidth;
            var transformationData = __assign({}, data);
            if (naturalHeight === null || naturalWidth === null) {
                _this.props.onSubmit(transformationData);
                return;
            }
            if (naturalHeight > MAX_SIZE || naturalWidth > MAX_SIZE) {
                var ratio = naturalHeight / naturalWidth;
                var MAX_WIDTH = MAX_SIZE;
                var MAX_HEIGHT = MAX_SIZE;
                if (naturalWidth >= naturalHeight) {
                    MAX_HEIGHT = MAX_SIZE * ratio;
                }
                else {
                    MAX_WIDTH = MAX_SIZE * ratio;
                }
                // potrebujeme urobit prepocet, inak vyrez nebude sediet
                transformationData.x = Math.round((transformationData.x * naturalWidth) / MAX_WIDTH);
                transformationData.y = Math.round((transformationData.y * naturalHeight) / MAX_HEIGHT);
                transformationData.width = Math.round((transformationData.width * naturalWidth) / MAX_WIDTH);
                transformationData.height = Math.round((transformationData.height * naturalHeight) / MAX_HEIGHT);
            }
            _this.props.onSubmit(transformationData);
        };
        _this.state = {
            naturalWidth: null,
            naturalHeight: null,
        };
        _this.imgEl = null;
        _this.cropper = null;
        return _this;
    }
    MediaManagerPhotoEditor.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var imageUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageUrl = config_1.default.MEDIAMANAGER_URL + "/media/" + this.props.picture.uri;
                        if (this.props.picture.public_url) {
                            imageUrl = this.props.picture.public_url;
                        }
                        // @TODO otestovat chybovy stav
                        return [4 /*yield*/, this.loadImageDimensions(imageUrl)];
                    case 1:
                        // @TODO otestovat chybovy stav
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaManagerPhotoEditor.prototype.loadImageDimensions = function (imageUri) {
        return __awaiter(this, void 0, void 0, function () {
            var img;
            var _this = this;
            return __generator(this, function (_a) {
                img = new Image();
                img.src = imageUri;
                return [2 /*return*/, new Promise(function (resolve) {
                        img.addEventListener('load', function (e) {
                            var _a = e.target, naturalHeight = _a.naturalHeight, naturalWidth = _a.naturalWidth;
                            _this.setState({ naturalHeight: naturalHeight, naturalWidth: naturalWidth }, function () {
                                resolve();
                            });
                        });
                    })];
            });
        });
    };
    MediaManagerPhotoEditor.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, dimensions = _a.picture.dimensions, picture = _a.picture, availableAspectRatios = _a.availableAspectRatios, mask = _a.mask;
        var pictureWithoutDimensions = __assign({}, picture);
        delete pictureWithoutDimensions['dimensions'];
        return (React.createElement(PhotoEditor_1.default, { src: MediaManagerImage_1.getMediaManagerUrl(pictureWithoutDimensions, MAX_SIZE, MAX_SIZE, 'resize'), onClose: onClose, onSubmit: this.handleSubmit, viewMode: 1, data: dimensions
                ? {
                    x: dimensions.X,
                    y: dimensions.Y,
                    width: dimensions.W,
                    height: dimensions.H,
                }
                : undefined, availableAspectRatios: availableAspectRatios, mask: mask }));
    };
    MediaManagerPhotoEditor.defaultProps = {
        availableAspectRatios: ['4:3', '16:9', '1:1', null],
    };
    return MediaManagerPhotoEditor;
}(React.PureComponent));
exports.default = MediaManagerPhotoEditor;
